import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Carlos Mendoza',
  role: 'Realtor Luxury',
  img: 'https://i.pravatar.cc/150?img=11',
  text: 'Antes pasaba 2 horas pensando qué publicar sobre mis propiedades. Ahora copio un prompt, pongo los datos de la casa y tengo un caption perfecto en 30 segundos. Vale cada centavo.'
}, {
  name: 'Laura Gómez',
  role: 'Coach de Negocios',
  img: 'https://i.pravatar.cc/150?img=5',
  text: 'La sección de ventas es oro puro. Usé uno de los prompts para estructurar mi último email de lanzamiento y la tasa de conversión subió un 40%. Suena exactamente como yo.'
}, {
  name: 'David Torres',
  role: 'Agencia de Marketing',
  img: 'https://i.pravatar.cc/150?img=8',
  text: 'Compré esto pensando que sería otro PDF básico. Me equivoqué. Es un sistema completo. Se lo he pasado a todo mi equipo de copywriters para estandarizar procesos.'
}, {
  name: 'Sofía Ruiz',
  role: 'Creadora de Contenido',
  img: 'https://i.pravatar.cc/150?img=9',
  text: "El bono de 'Haz que la IA suene como tú' me voló la cabeza. Por fin ChatGPT dejó de sonar como un robot corporativo y empezó a usar mis expresiones. Increíble."
}];
export function Testimonials() {
  return <section id="testimonios" className="py-24 md:py-32 relative" data-id="element-346">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-347">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 md:mb-24" data-id="element-348">
          <h2 className="font-display text-4xl md:text-5xl text-cream mb-6" data-id="element-349">
            Lo que dicen los profesionales
          </h2>
          <p className="text-cream/60 max-w-2xl mx-auto text-lg font-light" data-id="element-350">
            Únete a cientos de emprendedores que ya están recuperando su tiempo.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-351">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-gradient-to-br from-black-200 to-black-100 border border-gold/15 p-8 rounded-sm hover:border-gold/40 hover:from-black-300 hover:to-black-200 transition-all duration-500 shadow-[0_4px_24px_-8px_rgba(0,0,0,0.6)] hover:shadow-[0_8px_32px_-4px_rgba(212,175,122,0.08)] relative overflow-hidden" data-id="element-352">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent opacity-60" data-id="element-353"></div>
              <div className="flex text-gold mb-6" data-id="element-354">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} size={16} fill="currentColor" data-id="element-355" />)}
              </div>

              <p className="text-cream/80 font-light leading-relaxed mb-8 text-lg" data-id="element-356">
                "{test.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-357">
                <img src={test.img} alt={test.name} className="w-12 h-12 rounded-full border border-gold/20 grayscale opacity-80" data-id="element-358" />
                <div data-id="element-359">
                  <h4 className="text-cream font-medium" data-id="element-360">{test.name}</h4>
                  <p className="text-gold/60 text-xs uppercase tracking-widest" data-id="element-361">
                    {test.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}